var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-highcharts',{ref:"highcharts",attrs:{"highcharts":_vm.Highcharts,"options":_vm.chartOption}})}
var staticRenderFns = []

export { render, staticRenderFns }